'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'computer-classic';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8b1';
var svgPathData = 'M384 16c26.5 0 48 21.5 48 48l0 304c0 26.5-21.5 48-48 48L64 416c-26.5 0-48-21.5-48-48L16 64c0-26.5 21.5-48 48-48l320 0zM64 0C28.7 0 0 28.7 0 64L0 368c0 23.7 12.9 44.4 32 55.4L32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-304c0-35.3-28.7-64-64-64L64 0zM48 480l0-50c5.1 1.3 10.5 2 16 2l320 0c5.5 0 10.9-.7 16-2l0 50c0 8.8-7.2 16-16 16L64 496c-8.8 0-16-7.2-16-16zM232 336c-4.4 0-8 3.6-8 8s3.6 8 8 8l144 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-144 0zM96 344a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 80l256 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L96 272c-8.8 0-16-7.2-16-16L80 96c0-8.8 7.2-16 16-16zM64 96l0 160c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComputerClassic = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;